import { StageActorLocal } from "@ginf/appcore-actor-addon";
import * as taskprocessor from "@ginf/appcore-taskprocessor"
import { DeclinePolicy, ReturnHandler } from "@ginf/appcore-taskprocessor";

let returnHandler = new ReturnHandler();
let processorSyncEventLoop = new taskprocessor.ProcessorSyncEventLoop(DeclinePolicy.Exception, returnHandler);

export const stage_quadient = new StageActorLocal(processorSyncEventLoop);
